import { Request } from '@mam/main/ApiClient';
import { ErpScenarioDetailResponse } from 'com.cogvio.pricemonitor.api';

export enum InternalServerError {
	'internal-server-error' = 'internal-server-error',
}

export enum ERPInterventonNameError {
	'erp-scenario-already-exists' = 'erp-scenario-already-exists',
}

const ReadableErrorCodes: { [maybeErrorCode: string]: string } = {
	[ERPInterventonNameError['erp-scenario-already-exists']]: 'This name is already taken by some other scenario!',
};

export type ERPScenarioError = InternalServerError | ERPInterventonNameError;

export const getHumanReadableErrorCode = (codes: Set<string>): string[] => {
	return Array.from(codes)
		.map((errorCode) => ReadableErrorCodes[errorCode])
		.filter(Boolean);
};

export class ERPInterventionRequest implements Request<ErpScenarioDetailResponse, ERPScenarioError> {
	public readonly knownErrorCodes = Object.values({ ...InternalServerError, ...ERPInterventonNameError });
	public readonly path: string;
	public readonly method = 'get';
	public readonly body: BodyInit | null = null;

	public constructor(userId: string, erpPackId: string, erpSessionId: string, scenarioId: string) {
		this.path = `users/${userId}/erp/packages/${erpPackId}/sessions/${erpSessionId}/scenarios/${scenarioId}`;
	}
}
